export default __webpack_public_path__ + "static/media/notation.0823f467.svg";